export default __webpack_public_path__ + "static/media/how-people-mobile.748895dd.jpg";